import { defineMessages, MessageDescriptor } from 'react-intl';

/**
 * GIP report export modal messages (Spanish defaults from es.json).
 */
export const gipExportMessages: Record<string, MessageDescriptor> = defineMessages({
  title: {
    id: 'audit.gipReport.export.title',
    defaultMessage: 'Exportar reporte de evidencia',
  },
  startBtn: {
    id: 'audit.gipReport.export.startBtn',
    defaultMessage: 'Iniciar',
  },
  retryBtn: {
    id: 'audit.gipReport.export.retryBtn',
    defaultMessage: 'Exportar nuevamente',
  },
  startNotification: {
    id: 'audit.gipReport.export.startNotification',
    defaultMessage: 'Export iniciado',
  },
  startNotificationError: {
    id: 'audit.gipReport.export.startNotificationError',
    defaultMessage: 'No se pudo iniciar el export',
  },
});
